import "./styles/index.scss";
import "dumb/icon/icons-sprite";
// import "../.modernizrrc";

import "./components/landing/Landing.js";
//components
import "./components/Datepicker.js";
import "./components/Fullpage.js";
import "./components/Parsley.js";
import "./components/Choices.js";
import "./components/popup.js";

$(function () {
	//RECAPTCHAF
	$(window).on('orientationchange', function () {
		if (grecaptcha) {
			grecaptcha.reset();
		};
	});
});



// WEBPACK FOOTER //
// ./static/index.js